import apiClient from "./httpClient";
import endpoints from "./endpoints";

export const filesApi = {
  upload: (formData, config) => apiClient.post(endpoints.file.upload(), formData, config),
  delete: (files, config) => apiClient.post(endpoints.file.delete(), files, config),
  deleteOne: (fileName, config) => apiClient.get(endpoints.file.deleteOne(fileName), config),
};

export default filesApi;
